const selectLabels = document.querySelectorAll(".custom-bag__form-select-label"),
  selectInputs = document.querySelectorAll(".custom-bag__form-select-input"),
  selectItems = document.querySelectorAll(".custom-bag__form-select-item"),
  currentPage = document.getElementById("custom-bag").getAttribute("data-page");

selectLabels.forEach((selectLabel) => {
  selectLabel.addEventListener("click", () => {
    const currentSelect = selectLabel.closest(".custom-bag__form-select");
    currentSelect.classList.toggle("open");

    document.querySelectorAll(".custom-bag__form-select").forEach((select) => {
      if (window.matchMedia("(min-width: 768px)").matches) {
        if (select !== currentSelect) select.classList.remove("open");
      }
    });
  });
});

// Add global event listener to close dropdowns when clicking outside
document.addEventListener("click", (event) => {
  document.querySelectorAll(".custom-bag__form-select").forEach((select) => {
    if (!select.contains(event.target) && window.matchMedia("(min-width: 768px)").matches) {
      select.classList.remove("open");
    }
  });
});

selectItems.forEach((selectItem) => {
  selectItem.addEventListener("click", (evt) => {
    evt.preventDefault();
    const select = selectItem.closest(".custom-bag__form-select");

    if (select.dataset.selectType == "single" && !selectItem.classList.contains("selected")) {
      select.classList.remove("open");
      select.querySelectorAll(".custom-bag__form-select-item").forEach((item) => {
        item.classList.remove("selected");
      });
      selectItem.classList.add("selected");
    } else if (select.dataset.selectType == "single" && selectItem.classList.contains("selected")) {
      select.classList.remove("open");
      selectItem.classList.toggle("selected");
    } else {
      selectItem.classList.toggle("selected");
    }

    updateSelectsValues();
    updateLocalStorage();
  });
});

const formInputs = document.querySelectorAll(".custom__quote-form input");
formInputs.forEach((formInput) => {
  formInput.addEventListener("click", () => {
    selectItems.forEach((selectItem) => {
      const select = selectItem.closest(".custom-bag__form-select"),
        selectInput = select.querySelector(".custom-bag__form-select-input");

      if (formInput.name == selectInput.name) {
        if (select.dataset.selectType === "single") {
          selectItem.classList.toggle("selected", formInput.value === selectItem.dataset.value);
        } else {
          if (formInput.value === selectItem.dataset.value) selectItem.classList.toggle("selected");
        }
      }
    });

    updateSelectsValues();
    updateLocalStorage();
  });
});

const formSubmit = document.querySelector(".custom-bag__submit-button");
formSubmit?.addEventListener("click", (event) => {
  event.preventDefault();

  const form = document.querySelector(".custom-bag__form");
  const formData = new FormData(form);

  const formResponse = {};
  formData.forEach((value, key) => {
    formResponse[key] = value;
  });

  if (!validateForm()) return;

  formSubmit.disabled = true;
  formSubmit.classList.add("disabled");

  fetch("https://formbuilder.hulkapps.com/forms/create_response/GzIidwDVdvhpsKR7_1mmeg", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "X-Form-Access-Token": "d4bd362f7be8253c",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      formResponse: formResponse,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      form.classList.add("form-success");

      formSubmit.disabled = false;
      formSubmit.classList.remove("disabled");
    })
    .catch((error) => {
      console.error("Error:", error);

      formSubmit.disabled = false;
      formSubmit.classList.remove("disabled");
    });
});

function validateForm() {
  const name = document.getElementById("custom_bag_name");
  const nameError = document.querySelector(".custom-bag__error--name");

  if (name.value == "") {
    nameError.textContent = "Please enter your contact name";
    return false;
  } else {
    nameError.textContent = "";
  }

  const phone = document.getElementById("custom_bag_phone_number");
  const phoneError = document.querySelector(".custom-bag__error--number");
  const phonePattern = /^[0-9]{10}$/;

  if (phone.value !== "" && !phonePattern.test(phone.value)) {
    phoneError.textContent = "Please enter a valid phone number";
    return false;
  } else {
    phoneError.textContent = "";
  }

  const email = document.getElementById("custom_bag_email_address");
  const emailError = document.querySelector(".custom-bag__error--email");
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  if (!emailPattern.test(email.value)) {
    emailError.textContent = "Please enter a valid email address";
    return false;
  } else {
    emailError.textContent = "";
  }

  // const customerType = document.querySelector('input[name="Customer Type"]:checked');
  // const customerTypeError = document.querySelector(".custom-bag__error--customer-type");
  // if (!customerType) {
  //   customerTypeError.textContent = "Please select your customer type";
  //   return false;
  // } else {
  //   customerTypeError.textContent = "";
  // }

  const location = document.getElementById("custom_bag_location");
  const locationError = document.querySelector(".custom-bag__error--location");
  if (location.value == "") {
    locationError.textContent = "Please enter your correct location";
    return false;
  } else {
    locationError.textContent = "";
  }

  return true;
}

updateFormData();

function updateSelectsValues() {
  selectItems.forEach((selectItem) => {
    const select = selectItem.closest(".custom-bag__form-select"),
      selectInput = select.querySelector(".custom-bag__form-select-input"),
      selectValue = select.querySelector(".custom-bag__form-select-value");

    const selectedValues = [];
    select.querySelectorAll(".custom-bag__form-select-item").forEach((item) => {
      if (item.classList.contains("selected")) selectedValues.push(item.dataset.value);
    });

    if (selectedValues.length) {
      selectInput.value = selectedValues.join(", ");
      selectValue.classList.remove("not-selected");
      selectValue.querySelector("span").textContent = selectedValues.join(", ");
    } else {
      selectInput.value = "";
      selectValue.classList.add("not-selected");
      selectValue.querySelector("span").textContent = `Select ${select.dataset.label}`;
    }
  });
}

function updateLocalStorage() {
  let customBagsData = localStorage.getItem(`customBags-${currentPage}`);
  customBagsData = customBagsData ? JSON.parse(customBagsData) : {};

  selectInputs.forEach((selectInput) => {
    customBagsData[selectInput.name] = selectInput.value !== `` ? selectInput.value.split(`, `) : [];
  });

  localStorage.setItem(`customBags-${currentPage}`, JSON.stringify(customBagsData));

  updateFormData();
}

function updateFormData() {
  let customBagsData = localStorage.getItem(`customBags-${currentPage}`);
  customBagsData = customBagsData ? JSON.parse(customBagsData) : {};

  if (Object.keys(customBagsData).length === 0) return;

  selectInputs.forEach((selectInput) => {
    const customBagsItem = customBagsData[selectInput.name];
    if (customBagsItem) {
      const select = selectInput.closest(".custom-bag__form-select"),
        selectValue = select.querySelector(".custom-bag__form-select-value"),
        selectItems = select.querySelectorAll(".custom-bag__form-select-item");

      if (customBagsItem.length) {
        selectInput.value = customBagsItem.join(", ");
        selectValue.classList.remove("not-selected");
        selectValue.querySelector("span").textContent = customBagsItem.join(", ");
      } else {
        selectInput.value = "";
        selectValue.classList.add("not-selected");
        selectValue.querySelector("span").textContent = `Select ${select.dataset.label}`;
      }

      selectItems.forEach((selectItem) => {
        if (customBagsItem.includes(selectItem.dataset.value)) {
          selectItem.classList.add("selected");
        } else {
          selectItem.classList.remove("selected");
        }
      });
    }
  });

  formInputs.forEach((formInput) => {
    const customBagsItem = customBagsData[formInput.name];
    formInput.checked = customBagsItem && customBagsItem.includes(formInput.value) ? true : false;
  });
}
